export default __webpack_public_path__ + "static/media/skapek.71239d78.png";